import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { getMaterialProductsByCategoryId } from '../../../api/materialSpecifications'
import { getMaterialProductsUOMsByCategoryId } from '../../../api/materialProductsUOMs'
import { searchAllMaterialList } from '../../../api/materialMaster'
import { raiseToast } from '../toast/toast'
import { getSearchActiveStatus, sortArrayOfObjectsInAlphabeticalOrder } from '../../../../utils'

export const fetchMaterialMasterListData = createAsyncThunk('materialMaster', async (params, { dispatch }) => {
    const response = await searchAllMaterialList(params)
    if(response.failure){
        dispatch(raiseToast({severity:'error', summary: response.data.error, detail: 'Invalid text', life: 3000}))
        throw Error()
    }
    return response.data

})

export const fetchMaterialProductsByCategoryId = createAsyncThunk('materialMaster/materialProductsByCategoryId', async (params) => {
    const response = await getMaterialProductsByCategoryId(params)
    const combinedResults = response.data.materialMasterResponse.concat(response.data.materialSpecificationsResponse);

    const sortedMaterialProducts = sortArrayOfObjectsInAlphabeticalOrder(combinedResults, 'productName')
    return sortedMaterialProducts
})

export const fetchMaterialProductsUOMsByCategoryId = createAsyncThunk('materialMaster/materialProductsUOMsByCategoryId', async (params) => {
    const response = await getMaterialProductsUOMsByCategoryId(params)
    return response.data
})

export const materialMasterSlice = createSlice({
    name : "materialMaster/inputSuggestions",
    initialState : {
        loading : false,
        isProductsByCaterogyLoading: false,
        isProductsUOMsByCaterogyLoading: false,
        materialProductsByCaterogy : [],
        materialProductsUOMsByCaterogy : [],
        materialMasterListData: [],
        paginationParams : {
            pageNo: 0,
            totalRecords: 0,
            recordsPerPage: 10,
            limitedPagination: true,
            getCount: true
        },
        materialMasterListPaginationParams : {
            pageNo: 0,
            totalRecords: 0,
            recordsPerPage: 10,
            limitedPagination: true,
            getCount: true,
            excessPagesFound: false
        },
        searchParams: {
            dataType: "materialMasterData",
            searchBy: "all",
            searchText: "" ,
            dateType: "createdAt",
        },
        searchOptions: [],
        isSearchVisible: true,
        isSearchActive: true,
        searchConfig: [],
        isSearchPinned: true,
        isSearchByLocked: false
    },
    reducers: {
        updateSearchOptions: (state, action) => {
            state.searchOptions = action.payload
        },
        updateSearchParams: (state, action) => {
            state.searchParams = action.payload  
            const parsedState = JSON.parse(JSON.stringify(state))

            const isSearchActive = getSearchActiveStatus(parsedState.searchParams, parsedState.searchConfig)

            state.isSearchActive = isSearchActive
        },
        updateMaterialItemData: (state, action) => {
            state.materialMasterListData = action.payload
        },
        updateMaterialProductsByCaterogy: (state, action) => {
            state.materialProductsByCaterogy = action.payload
        },
        updateMaterialProductsUOMsByCaterogy: (state, action) => {
            state.materialProductsUOMsByCaterogy = action.payload
        },
        setIsSearchVisible: (state, action) => {
            state.isSearchVisible = action.payload
        },
        setSearchConfig: (state, action) => {
            state.searchConfig = action.payload
        },
        setIsSearchPinned: (state, action) => {
            state.isSearchPinned = action.payload
        },
        setIsSearchByLocked: (state, action) => {
            state.isSearchByLocked = action.payload
        },
        updateSearchByParam: (state, action) => {
            const parsedState = JSON.parse(JSON.stringify(state))
            const availableOptions = parsedState.searchConfig.map(eachOption => eachOption.name)
            if(availableOptions.includes(action.payload.searchBy)){
                state.searchParams = {...parsedState.searchParams, ...action.payload}
            } else {
                state.searchParams = {...parsedState.searchParams, searchBy: "all", searchText: ""}
            }
        }
    },
    extraReducers : (builder) => {
        builder
        .addCase(
            fetchMaterialProductsByCategoryId.fulfilled, (state, action) => {
                state.isProductsByCaterogyLoading = false 
                state.materialProductsByCaterogy = action.payload
            }
        )
        .addCase(
            fetchMaterialProductsByCategoryId.pending, (state, action) => {
                state.isProductsByCaterogyLoading = true 
            }
        )
        .addCase(
            fetchMaterialProductsByCategoryId.rejected, (state, action) => {
                state.isProductsByCaterogyLoading = false
            }
        )
        .addCase(
            fetchMaterialProductsUOMsByCategoryId.fulfilled, (state, action) => {
                state.isProductsUOMsByCaterogyLoading = false 
                state.materialProductsUOMsByCaterogy = action.payload
            }
        )
        .addCase(
            fetchMaterialProductsUOMsByCategoryId.pending, (state, action) => {
                state.isProductsUOMsByCaterogyLoading = true 
            }
        )
        .addCase(
            fetchMaterialProductsUOMsByCategoryId.rejected, (state, action) => {
                state.isProductsUOMsByCaterogyLoading = false
            }
        )
        .addCase(
            fetchMaterialMasterListData.fulfilled, (state, action) => {
                state.loading = false 
                state.materialMasterListData = action.payload.data 
                state.materialMasterListPaginationParams.pageNo = action.payload.pageNo-1
                state.materialMasterListPaginationParams.recordsPerPage = action.payload.recordsPerPage
                if(action.payload.totalRecords || action.payload.totalRecords === 0){
                    state.materialMasterListPaginationParams.totalRecords = action.payload.totalRecords
                    state.materialMasterListPaginationParams.excessPagesFound = false
                }
                if(action.payload.excessPagesFound || !action.payload.excessPagesFound){
                    if(!state.materialMasterListPaginationParams.excessPagesFound){
                        state.materialMasterListPaginationParams.excessPagesFound = action.payload.excessPagesFound
                    }else if(action.payload.excessPagesFound === false){
                        state.materialMasterListPaginationParams.excessPagesFound = false
                    }
                }  
                if(state.materialMasterListData.length && !state.isSearchPinned){
                    state.isSearchVisible = false
                }     
            }
        )
        .addCase(
            fetchMaterialMasterListData.pending, (state, action) => {
                state.loading = true 
            }
        )
        .addCase(
            fetchMaterialMasterListData.rejected, (state, action) => {
                state.loading = false
                state.materialMasterListData = []
                state.materialMasterListPaginationParams.totalRecords = 0
                state.materialMasterListPaginationParams.excessPagesFound = false
            }
        )
    }
})

export const { 
    updateSearchOptions, 
    updateSearchParams, 
    updateMaterialItemData,
    updateMaterialProductsByCaterogy,
    updateMaterialProductsUOMsByCaterogy,
    setIsSearchVisible,
    setSearchConfig,
    setIsSearchPinned,
    setIsSearchByLocked
} = materialMasterSlice.actions

export default materialMasterSlice.reducer